import * as React from 'react';
var SvgQrCode = () => /*#__PURE__*/React.createElement("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.75 16a.75.75 0 0 1 .75.75v.5c0 .69.56 1.25 1.25 1.25h.5a.75.75 0 0 1 0 1.5h-.5A2.75 2.75 0 0 1 4 17.25v-.5a.75.75 0 0 1 .75-.75Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.25 14c.966 0 1.75.784 1.75 1.75v2.5A1.75 1.75 0 0 1 18.25 20h-2.5A1.75 1.75 0 0 1 14 18.25v-2.5c0-.966.784-1.75 1.75-1.75h2.5Zm-2.5 1.5a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25h-2.5Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.25 12A2.75 2.75 0 0 1 11 14.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.69-.56-1.25-1.25-1.25h-2.5a.75.75 0 0 1 0-1.5h2.5ZM19.25 10.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5h6.5Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.25 4C9.216 4 10 4.784 10 5.75v2.5A1.75 1.75 0 0 1 8.25 10h-2.5A1.75 1.75 0 0 1 4 8.25v-2.5C4 4.784 4.784 4 5.75 4h2.5Zm-2.5 1.5a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25h-2.5Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.25 4A2.75 2.75 0 0 1 20 6.75v1.5a.75.75 0 0 1-1.5 0v-1.5c0-.69-.56-1.25-1.25-1.25h-1.5a.75.75 0 0 1 0-1.5h1.5ZM15.25 7a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5h2.5Z",
  fill: "currentColor"
}));
export default SvgQrCode;